<script setup lang="ts">
interface Props {
  error: string
}

defineProps<Props>()

const emit = defineEmits<{
  retry: []
}>()
</script>

<template>
  <div class="flex flex-col items-center justify-center py-20">
    <div class="text-destructive text-6xl mb-4">⚠️</div>
    <p class="text-destructive mb-4">{{ error || '加载失败，请稍后重试' }}</p>
    <button
      @click="emit('retry')"
      class="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
    >
      重新加载
    </button>
  </div>
</template>
